import useHasPermission from './useHasPermission';

const useHasRoutePermission = (path: string): boolean => {
  return useHasPermission(`web:${path}`);
};

export default useHasRoutePermission;
